var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/*
 * Copyright 2019 the original author or authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @author Steven Gentens
 * @since 2.2.0
 */
import BaseControlAdapter from '../support/base-control-adapter';
import { createControlValueHolder } from '../support/bootstrap-ui-control-value-holder';
/**
 * {@link BootstrapUiControlAdapter} for autonumeric elements.
 * The target of the control adapter is the node on which it is registered.
 *
 * @see numericInitializer
 */
var NumericControlAdapter = /** @class */ (function (_super) {
    __extends(NumericControlAdapter, _super);
    function NumericControlAdapter(target) {
        var _this = _super.call(this, target) || this;
        _this.initialValue = _this.getAutoNumeric().get();
        $(target).on('change', function (event) { return _this.triggerChange(); });
        return _this;
        // TODO configure 'bootstrapui.submit' event
        // prevent opening the element on enter, but see it as 'submitting' the value instead.
        // $( target ).on( 'keypress', ( event ) => {
        //     if ( event.key === 'Enter' ) {
        //         this.triggerSubmit();
        //     }
        // } );
    }
    NumericControlAdapter.prototype.getValue = function () {
        var label = $(this.getTarget()).val().toString();
        var value = this.getAutoNumeric().get();
        return [createControlValueHolder(label, value, this.getTarget())];
    };
    NumericControlAdapter.prototype.reset = function () {
        this.selectValue(this.initialValue);
    };
    NumericControlAdapter.prototype.selectValue = function (newValue) {
        this.getAutoNumeric().set(newValue);
    };
    NumericControlAdapter.prototype.getAutoNumeric = function () {
        return $(this.getTarget()).data('autoNumeric');
    };
    return NumericControlAdapter;
}(BaseControlAdapter));
export default NumericControlAdapter;
/**
 * Initializes a {@link NumericControlAdapter} for a given node.
 *
 * @param node to initialize
 */
export function createNumericControlAdapter(node) {
    return new NumericControlAdapter(node);
}
